import React, { useState } from "react";
import FontPanelGoogle from "../FontPanelGoogle";
import FontPanelUpload from "../FontPanelUpload";
import styles from "./DesignSettingsFont.module.css";
import ActiveFontsPanel from "./ActiveFontsPanel";

const DesignSettingsFont = ({ designContext, theme, removeFont, addFont }) => {
  const [unsavedFonts, setUnsavedFonts] = useState([]);

  const fonts = theme.get("fonts", false);

  const _fontExists = (fontName) => fonts.has(fontName);

  const _addFont = (fonts) => {
    addFont(fonts);
    const newUnsavedFonts = Array.isArray(fonts)
      ? fonts.map((f) => f.get("name"))
      : [fonts.get("name")];
    setUnsavedFonts([...unsavedFonts, ...newUnsavedFonts]);
  };

  const _removeFont = (fontName) => {
    removeFont(fontName);
    setUnsavedFonts(unsavedFonts.filter((unsavedFont) => unsavedFont !== fontName));
  };

  return (
    <div className="panel-fonts">
      <div className={styles["font-list-container"]}>
        <FontPanelGoogle
          removeFont={_removeFont}
          addFont={_addFont}
          fontExists={_fontExists}
          fonts={fonts}
          designContext={designContext}
        />
        <div className={styles["panel-fonts-divider"]} />
        <FontPanelUpload
          removeFont={_removeFont}
          addFont={_addFont}
          fontExists={_fontExists}
          designContext={designContext}
        />
      </div>
      <ActiveFontsPanel
        fonts={fonts}
        designContext={designContext}
        removeFont={_removeFont}
        unsavedFonts={unsavedFonts}
      />
    </div>
  );
};

export default DesignSettingsFont;
